// Fim de partida com a próxima ação (lote 3, item 16). Sempre há uma, em destaque, nesta ordem:
// 1. revanche com os mesmos 6 (a mesa sabe; o aparelho põe na frente);
// 2. missão que falta 1 partida para fechar;
// 3. barra de nível ou de passe quase cheia ("Falta 1 partida para o nível 8");
// 4. Rodada quente ativa ("Emende a próxima: +50%");
// 5. jogar de novo na liga; com a liga oculta (LIGA_DA_SEMANA = false), ver as salas abertas.
import { LIGA_DA_SEMANA } from '@truco6/planos';
import type { MissaoFechada } from './missoes.ts';
import type { PasseNoFim } from './passe.ts';
import { type RodagemNoFim, type ValoresRecompensa, bonusQuente } from './recompensas.ts';

export type ProximaAcao =
  | { tipo: 'revanche' }
  | { tipo: 'missao'; titulo: string; rodagem: number }
  | { tipo: 'nivel'; nivel: number }
  | { tipo: 'passe'; nivel: number }
  | { tipo: 'quente'; bonus: number }
  | { tipo: 'liga' }
  | { tipo: 'salas' };

export interface CondicoesDoFim {
  missaoPerto: MissaoFechada | null; // a missão que fecha com mais 1 partida
  rodagem: RodagemNoFim | null;
  passe: PasseNoFim | null;
}

// A próxima ação do que a gamificação sabe (sem a revanche). Uma partida rende pelo menos rodagem_partida de Rodagem
// e 1 estrela do passe.
export function proximaAcao(c: CondicoesDoFim, v: ValoresRecompensa): ProximaAcao {
  if (c.missaoPerto) return { tipo: 'missao', titulo: c.missaoPerto.titulo, rodagem: c.missaoPerto.rodagem };
  const r = c.rodagem, p = c.passe;
  if (r && r.nivel.paraOProximo - r.nivel.noNivel <= v.rodagem_partida) return { tipo: 'nivel', nivel: r.nivel.nivel + 1 };
  if (p && p.nivel.depois < p.niveis && p.estrelasPorNivel - (p.total % p.estrelasPorNivel) <= 1) return { tipo: 'passe', nivel: p.nivel.depois + 1 };
  if (r && r.quente.nivel >= 1) return { tipo: 'quente', bonus: bonusQuente(r.quente.nivel + 1, v) };
  return ultimaAcao();
}
const ultimaAcao = (): ProximaAcao => (LIGA_DA_SEMANA ? { tipo: 'liga' } : { tipo: 'salas' });

// No aparelho: a revanche com os mesmos 6 vem antes de tudo.
export function acaoDoFim(revancheComOs6: boolean, proxima: ProximaAcao | null | undefined): ProximaAcao {
  return revancheComOs6 ? { tipo: 'revanche' } : proxima ?? ultimaAcao();
}
